// shared helpers for keeping the big image, image grid and mobile thumbnail
// strip in sync with whichever variant image is currently shown, used by
// both changeVariant (user click) and changeFirstImageOnLoad (page load)
function normalizeImageUrl(u) {
  if (!u) return '';
  // handle protocol-relative URLs from Shopify CDN
  if (u.startsWith('//')) return window.location.protocol + u;
  return u;
}

function buildSizedImageUrl(base, width, height) {
  const src = normalizeImageUrl(base);
  try {
    const url = new URL(src, window.location.origin);
    if (width) url.searchParams.set('width', String(width));
    if (height) url.searchParams.set('height', String(height));
    return url.toString();
  } catch (e) {
    // fallback: append params conservatively
    const sep = src.includes('?') ? '&' : '?';
    const w = width ? `&width=${width}` : '';
    const h = height ? `&height=${height}` : '';
    return `${src}${sep}crop=center${w}${h}`;
  }
}

function getImagePathname(src) {
  try {
    return new URL(src, window.location.origin).pathname;
  } catch (e) {
    return (src || '').split('?')[0];
  }
}

// the grid still shows the newly chosen variant's photo in its own tile,
// duplicating the big image - swap that tile back to the photo that just
// got pushed out of the big image slot so nothing is lost
function preserveReplacedGridImage(previousImgEl, previousLinkEl, newSrc) {
  const imagesGrid = document.querySelector('.images');
  if (!imagesGrid || !previousImgEl || !previousImgEl.src) return;

  const newPath = getImagePathname(newSrc);
  const targetImg = Array.from(imagesGrid.querySelectorAll('img')).find(
    (img) => getImagePathname(img.src) === newPath
  );
  if (!targetImg) return;

  const targetLink = targetImg.closest('a');
  targetImg.src = previousImgEl.src;
  targetImg.alt = previousImgEl.alt || targetImg.alt;
  if (targetLink) targetLink.setAttribute('href', (previousLinkEl && previousLinkEl.href) || previousImgEl.src);
}

// keep the mobile thumbnail strip's highlighted thumb in sync with
// whichever image ends up in the mobile big image slot
function highlightMobileThumb(newSrc) {
  const thumbs = document.querySelectorAll('.mobileImages .imageThumb');
  if (!thumbs.length) return;

  const newPath = getImagePathname(newSrc);
  let matchedThumb = null;
  thumbs.forEach((thumb) => {
    thumb.classList.remove('!border-[var(--abYellow)]', 'border-2');
    thumb.classList.add('border');
    const thumbImg = thumb.querySelector('img');
    if (!matchedThumb && thumbImg && getImagePathname(thumbImg.src) === newPath) {
      matchedThumb = thumb;
    }
  });

  if (matchedThumb) {
    matchedThumb.classList.remove('border');
    matchedThumb.classList.add('!border-[var(--abYellow)]', 'border-2');
    const index = matchedThumb.getAttribute('data-image-index');
    if (index !== null && typeof currentImageIndex !== 'undefined') {
      currentImageIndex = parseInt(index, 10);
    }
  }
}

// change variant updater on product page
function changeVariant(ele) {
  let itemElement = document.getElementsByClassName("dropDownItem");
  let selector = ele.parentElement;

  let noOption;
  for (let i = 0; i < selector.children.length; i++) {
    selector.children[i].classList.remove("chosen");
    if (selector.children[i].classList.contains("noOption")) {
      noOption = selector.children[i];
    }
  }

  selector.insertBefore(noOption, selector.firstElementChild);
  selector.insertBefore(ele, selector.firstElementChild);

  ele.className += " chosen";
  if (selector.classList.contains("open")) {
    selector.classList.remove("open");
    selector.classList.remove("delayShow");
  } else {
    selector.className += " open";
    setTimeout(function () {
      selector.className += " delayShow";
    }, 50);
  }

  // update price
  let variantPrice = ele.children[1].children[1].children[0].innerText;
  let priceSpan = document.getElementById("productPrice");
  let oldPriceSpan = document.getElementById("oldProductPrice");
  priceSpan.innerText = variantPrice;
  if (oldPriceSpan) {
    oldPriceSpan.style.display = "none";
  }
  //update form data
  let formVariantField = document.getElementById("variant-id");
  formVariantField.value = ele.id;

  // update voorraad en levertijd
  let variantVoorraad = ele.children[1].children[1].children[1].innerText;
  let voorraadSpan = document.getElementById("voorraadSpan");
  let levertijdSpan = document.getElementById("levertijdSpan");

  const isOutOfStock = variantVoorraad == "Niet op voorraad";
  formVariantField.disabled = isOutOfStock;
  const mainBtn = document.getElementById("main-add-to-cart-btn");
  if (mainBtn) {
    mainBtn.disabled = isOutOfStock;
    mainBtn.style.display = isOutOfStock ? 'none' : '';
  }
  const quantityInput = document.querySelector('#maatwerkForm quantity-input');
  if (quantityInput) quantityInput.style.display = isOutOfStock ? 'none' : '';
  if (levertijdSpan) levertijdSpan.style.display = isOutOfStock ? 'none' : '';

  if (isOutOfStock) {
    voorraadSpan.innerText = "Niet op voorraad";
    voorraadSpan.className = "clear-both text-[#15803D] text-[12px] md:text-[14px] font-medium font-medium block py-1 !text-[var(--abRed)]";
  } else {
    voorraadSpan.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="float-left text-[#15803D] mr-1 w-5 h-5"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path></svg>Op voorraad';
    voorraadSpan.className = "flex text-[#15803D] font-medium py-1";
  }
  // update verzend tijd + usp verzendtijd op basis van matrix
  let variantMatrix = ele.getAttribute("data-matrix");
  uspElement = document.querySelector("div.uspSales > ul > li:nth-child(1) > span");
  if (variantMatrix == "D" && voorraadSpan.innerText != 'Niet op voorraad') {
    levertijdSpan.innerText = "Levertijd: 3-5 dagen";
    uspElement.innerText = "Levertijd: 3-5 dagen";
  } else if (voorraadSpan.innerText != 'Niet op voorraad') {
    levertijdSpan.innerHTML =
      'Voor 15:00 besteld,<span class="font-semibold"> volgende werkdag</span> bezorgd*';
    uspElement.innerHTML =
      'Voor 15:00 besteld,<span class="font-semibold"> volgende werkdag</span> bezorgd*';
  }

  // update image using high-res base from data-image (fallback to thumbnail img src)
  const baseImage = ele.dataset.image || (ele.children[0] && ele.children[0].src) || '';
  const variantImageDesktop = buildSizedImageUrl(baseImage, 500, 550);
  const variantImageMobile = buildSizedImageUrl(baseImage, 300, 350);

  // change main image
  let mainImage = document.querySelector(".bigImage div a img");
  let mainImageLink = document.querySelector(".bigImage div a");
  if (mainImage && mainImageLink && variantImageDesktop) {
    preserveReplacedGridImage(mainImage, mainImageLink, variantImageDesktop);
    mainImage.src = variantImageDesktop;
    mainImageLink.href = variantImageDesktop;
  }

  // also update mobile big image
  const mobileImg = document.querySelector('.mobileBigImage img');
  const mobileLink = document.querySelector('.mobileBigImage a');
  if (mobileImg && mobileLink && variantImageMobile) {
    mobileImg.src = variantImageMobile;
    mobileLink.href = variantImageMobile;
    highlightMobileThumb(variantImageMobile);
  }

  // update specs
  let specs = document.querySelectorAll(".specs");
  specs.forEach((element) => {
    if (element.classList.contains(ele.id)) {
      element.style.display = "table-row";
    } else {
      element.style.display = "none";
    }
  });
}

function changeFirstImageOnLoad() {
  // console.log('image changed on load');
  let variantSelector = document.querySelector('.dropDownSelector');

  let variantSelectorCheck = document.querySelector('#variantSelector')

  if (variantSelectorCheck != null) {
    let chosenItem = variantSelector.querySelector('.dropDownItem.chosen');
    let base = '';
    if (chosenItem) {
      base = chosenItem.dataset.image || (chosenItem.querySelector('img') && chosenItem.querySelector('img').src) || '';
    }

    if (base) {
      const desktopVariant = buildSizedImageUrl(base, 500, 550);
      const mobileVariant = buildSizedImageUrl(base, 300, 350);

      // preload before swapping so a broken/mismatched variant image
      // never leaves the big image blank - it just keeps the current one
      const swapImage = (imgEl, linkEl, newSrc, { preserveReplaced, onSwap } = {}) => {
        if (!imgEl || !linkEl || !newSrc) return;
        const previousSrc = imgEl.src;
        const preload = new Image();
        preload.onload = () => {
          if (preserveReplaced) preserveReplacedGridImage(imgEl, linkEl, newSrc);
          imgEl.src = newSrc;
          linkEl.href = newSrc;
          if (onSwap) onSwap(newSrc);
        };
        preload.onerror = () => {
          imgEl.src = previousSrc;
          linkEl.href = previousSrc;
        };
        preload.src = newSrc;
      };

      swapImage(document.querySelector('.bigImage div a img'), document.querySelector('.bigImage div a'), desktopVariant, { preserveReplaced: true });
      swapImage(document.querySelector('.mobileBigImage img'), document.querySelector('.mobileBigImage a'), mobileVariant, { onSwap: highlightMobileThumb });
    }
  }
}
document.addEventListener("DOMContentLoaded", function () {
  changeFirstImageOnLoad();
});
